<ng-container *ngIf="relatedProperties | hasRelatedProperties: 2, else normalRender">

    <ng-container *ngFor="let relatedProperty of $any(relatedProperties)
        | sortNumericProperty : 'productCapacity'
        | keyvalue: keyValueSort ; trackBy: trackByRelatedPropertyKey">

        <ng-container *ngIf="$any(relatedProperty.key) as key">

            <fieldset class="variants" *ngIf="key === 'primaryColor'">
                <legend class="display-label property-label">
                    {{ 'productDetail.property.' + key | translate }} <b>{{ selectedVariant | getSelectedVariant: key }}</b>
                </legend>

                <div class="thumbnails-wrapper">
                    <div #thumbnails (appNgAfterViewInit)="onElementViewInit(thumbnails)" [attr.property]="key" class="thumbnails scroll-snap" [ngClass]="{
                        'thumbnails--open': showMoreOpen
                    }">
                        <app-selection-thumb
                            class="thumbnail"
                            *ngFor="let variant of (relatedProperty.value | getVariantFromRelatedProperty: relatedProperty.key : variants); trackBy: trackItemByVariantNo"
                            [attr.aria-selected]="variant.productNo === selectedVariant?.productNo"
                            [id]="variant.productNo"
                            [title]="variant.productName || ''"
                            [control]="formGroup.controls['primaryColor']"
                            [value]="(variant.primaryColor | getMatchColor | async)?.colorId"
                        >
                            <app-product-image
                                class="image"
                                [image]="variant.imageUrl | urlToImage: { name: variant.productName }"
                                [width]="48"
                                [height]="48"
                                wrapperWidth="48px"
                                wrapperHeight="48px"
                                preset="94|94"
                                preset2x="150|150"
                                variant="white-background"
                            ></app-product-image>
                        </app-selection-thumb>
                        <ng-container *ngIf="showMoreButton" [ngTemplateOutlet]="showMore"></ng-container>
                    </div>
                </div>
            </fieldset>

            @if (key !== 'primaryColor') {
                <fieldset class="sizes">
                    <legend class="display-label property-label">
                        {{ 'productDetail.property.' + key | translate }} <b>{{ selectedVariant | getSelectedVariant: key }}</b>
                    </legend>
                    @if (formGroup.get(key); as control) {
                        <app-selection
                            *ngFor="let variant of $any(relatedProperty.value)"
                            [control]="formGroup.controls[$any(relatedProperty.key)]"
                            [disabled]="variant?.inactive"
                            [value]="variant.value"
                        >
                            {{ variant.key }} {{ variant.unit?.text }}
                        </app-selection>
                    }
                </fieldset>
            }
        </ng-container>
    </ng-container>
</ng-container>


<ng-template #showMore>
    <button class="btn-show-more"
        [ngClass]="{
            'btn-show-more--open': showMoreOpen
        }"
        (click)="onShowMore()"
        [innerHTML]="
            (showMoreOpen ? 'general.action.showLess' : 'general.action.showMore') | translateSafe: { sign: showMoreOpen ? '-' : '+', numOf: numOfHiddenThumbnails }"
    >
    </button>
</ng-template>

<ng-template #normalRender>
        <fieldset
            class="sizes"
            *ngFor="
                    let relatedProperty of $any(relatedProperties)
                        | sortNumericProperty : 'productCapacity'
                        | filterRelatedColor
                        | keyvalue
                "
        >
            <legend class="display-label property-label">
                {{ 'productDetail.property.' + relatedProperty.key | translate }}
            </legend>
            <app-selection
                *ngFor="let variant of $any(relatedProperty.value)"
                [control]="formGroup.controls[$any(relatedProperty.key)]"
                [value]="variant.value"
            >
                {{ variant.key }} {{ variant.unit?.text }}
            </app-selection>
        </fieldset>
        <fieldset
            class="colors"
            *ngFor="let relatedProperty of $any(relatedProperties) | filterRelatedColor : true | keyvalue"
        >
            <legend class="display-label property-label">
                {{ 'productDetail.property.' + relatedProperty.key | translate }}
            </legend>
            <ng-container *ngFor="let color of $any(relatedProperty.value)">
                <app-radio
                    *ngIf="(settingsService.settings$ | async)?.productSettings?.productColors as productColors"
                    [control]="formGroup.controls['primaryColor']"
                    [value]="color.key"
                    [color]="(color.key | matchColor : productColors)?.colorHexValue || ''"
                    [inverted]="true"
                    [inline]="true"
                    contentType="hidden"
                    [title]="(color.key | matchColor : productColors)?.colorName"
                >{{ (color.key | matchColor : productColors)?.colorName }}</app-radio>
            </ng-container>
        </fieldset>
</ng-template>
